<ng-container *transloco="let t">
  <div class="certificate-form">
    <div class="followup-row">
      <label class="followup-label">{{ t('Follow-up check in') }}</label>
      <mat-form-field appearance="outline" class="followup-input">
        <input matInput type="number" min="0" [formControl]="followUpDays" />
      </mat-form-field>
      <span class="days-label">{{ t('days') }}</span>
    </div>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Additional notes') }}</mat-label>
      <textarea matInput rows="5" [formControl]="additionalNotes"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput [formControl]="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
